<template>
    <section class="stealth-flow-recipient">
        <div class="grid-container">
            <div class="profile-label">
                Flow recipient
            </div>
        </div>
        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="flowRecipientList"
                    align="center"
                    data-qa="flow-recipient-table"
                >
                    <ds-table-grid-column
                        label="Id"
                        width="90"
                        data-qa="flow-recipient-id"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.id }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Funnel id"
                        width="90"
                        data-qa="flow-recipient-funnel-id"
                    >
                        <template slot-scope="recipient">
                            <span :title="recipient.funnelId">
                                {{ recipient.funnelId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Flow id"
                        width="90"
                        data-qa="flow-recipient-flow-id"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.flowId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Contactable type"
                        width="130"
                        data-qa="flow-recipient-contactable-type"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.contactableType }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Contactable id"
                        width="110"
                        data-qa="flow-recipient-contactable-id"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.contactableId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Contact id"
                        width="110"
                        data-qa="flow-recipient-contact-id"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.contactId }}
                            </span>
                        </template>
                    </ds-table-grid-column>


                    <ds-table-grid-column
                        label="User id"
                        width="90"
                        data-qa="flow-recipient-user-id"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.userId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Start date"
                        width="170"
                        data-qa="flow-recipient-start-date"
                    >
                        <template slot-scope="recipient">
                            <span :title="recipient.startDate">
                                {{ recipient.startDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Stop date"
                        width="170"
                        data-qa="flow-recipient-stop-date"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.stopDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="In queue"
                        width="120"
                        data-qa="flow-recipient-in-queue"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.inQueue }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Bulk"
                        width="120"
                        data-qa="flow-recipient-bulk"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.bulk }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Migrating"
                        width="120"
                        data-qa="flow-recipient-migrating"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.migrating }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Scheduling"
                        width="120"
                        data-qa="flow-recipient-scheduling"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.scheduling }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Count"
                        width="90"
                        data-qa="flow-recipient-count"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.count }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date created"
                        width="170"
                        data-qa="flow-recipient-date-created"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.dateCreated }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Last updated"
                        width="170"
                        data-qa="flow-recipient-last-updated"
                    >
                        <template slot-scope="recipient">
                            <span>
                                {{ recipient.lastUpdated }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
            <div v-if="!noResultsToDisplay">
                <p class="no-details-label">
                    No results to display
                </p>
            </div>
        </template>
    </section>
</template>

<script>
export default {
    props: {
        flowRecipientList: Array,
    },

    computed: {
        noResultsToDisplay() {
            return this.flowRecipientList?.length > 0;
        },
    },
};
</script>
<style lang="scss" scoped>
    .grid-container {
        margin: $spacing-250 0;
        display: flex;
    }

    .profile-label {
        margin: auto;
        font-size: 1.75rem;
        color: $color-text;
    }

    .table-scroller {
        overflow:auto;
        white-space: nowrap;
    }

    @media only screen and ($medium) {
        .grid-container {
            margin-top: 1.875rem;
            display: block;
        }
    }

    .stealth-flow-recipient {
        display: grid;
    }

    .no-details-label {
        color: $color-gray-darker;
        font-size: $font-size-lg;
        font-weight: 300;
        padding-top: $spacing-400;
    }
</style>
